export function changeSelectedEntity(entityId, type) {
    return {
        type: 'CHANGE_SELECTED_ENTITY',
        payload: {entityId: entityId, type: type} 
    };
}